// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.DashboardCardCompose-container {
  position: relative;
}
.DashboardCardCompose-container .card-wrapper {
  height: 297px;
}
.DashboardCardCompose-container:hover .DashboardOptionsDropdown {
  visibility: visible;
  opacity: 1;
}
.DashboardCardCompose-container:hover .DashboardCard-title {
  color: var(--color_primary_500);
}
.DashboardCardCompose-container:hover .CardThumbnail {
  opacity: 0.8;
}
.DashboardCardCompose-container .DashboardCard-body {
  display: grid;
  grid-template-rows: 16px 1fr;
  grid-row-gap: var(--spacing_unit_4);
  row-gap: var(--spacing_unit_4);
}
.DashboardCardCompose-container .DashboardCard-body .DashboardCard-body-badges {
  display: flex;
  align-items: center;
}
.DashboardCardCompose-container .DashboardCard-body .DashboardCard-body-badges [class^=dist_Badge] {
  display: flex;
}
.DashboardCardCompose-container .DashboardCard-body .DashboardCard-body-badges > :not(:last-child) {
  margin-right: 8px;
}
.DashboardCardCompose-container .DashboardCard-title {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.DashboardCardCompose-container .DashboardCard-description {
  font-size: 12px;
  color: var(--color_neutral_900);
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  margin-top: 10px;
}
.DashboardCardCompose-container .DashboardCard-jobType {
  font-size: 10px;
  color: var(--color_neutral_500);
}
.DashboardCardCompose-container .DashboardCard-details {
  font-size: 12px;
  color: var(--color_neutral_500);
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.CardMenu-container {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  transition: 0.16s ease-in-out;
  visibility: hidden;
  opacity: 0;
}
.CardMenu-container .CardMenu-button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(43, 43, 43, 0.3);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.CardMenu-container .CardMenu-button:hover {
  background: rgba(208, 178, 255, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/DashboardCard/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,kBAAA;AAeF;AAbE;EACE,aAAA;AAeJ;AAXI;EACE,mBAAA;EACA,UAAA;AAaN;AAVI;EACE,+BAAA;AAYN;AATI;EACE,YAAA;AAWN;AAPE;EACE,aAAA;EACA,4BAAA;EACA,mCAAA;EAAA,8BAAA;AASJ;AAPI;EACE,aAAA;EACA,mBAAA;AASN;AAPM;EACE,aAAA;AASR;AANM;EACE,iBAAA;AAQR;AAHE;ED1CA,oBAAA;EACA,aC0CsB;EDzCtB,qBCyCsB;EDxCtB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACsDtC;AAPE;EACE,eAAA;EACA,+BAAA;EDhDF,oBAAA;EACA,aCgDsB;ED/CtB,qBC+CsB;ED9CtB,4BAAA;EACA,gBAAA;EACA,sBANoC;ECmDlC,gBAAA;AAcJ;AAXE;EACE,eAAA;EACA,+BAAA;AAaJ;AAVE;EACE,eAAA;EACA,+BAAA;ED5DF,oBAAA;EACA,aC4DsB;ED3DtB,qBC2DsB;ED1DtB,4BAAA;EACA,gBAAA;EACA,sBANoC;AC+EtC;;AAbA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;EAEA,kBAAA;EACA,UAAA;AAeF;AAbE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAeJ;AAbI;EACE,oCAAA;AAeN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.DashboardCardCompose-container {\n  position: relative;\n\n  .card-wrapper {\n    height: 297px;\n  }\n\n  &:hover {\n    .DashboardOptionsDropdown {\n      visibility: visible;\n      opacity: 1;\n    }\n\n    .DashboardCard-title {\n      color: var(--color_primary_500);\n    }\n\n    .CardThumbnail {\n      opacity: 0.8;\n    }\n  }\n\n  .DashboardCard-body {\n    display: grid;\n    grid-template-rows: 16px 1fr;\n    row-gap: var(--spacing_unit_4);\n\n    .DashboardCard-body-badges {\n      display: flex;\n      align-items: center;\n\n      [class^='dist_Badge'] {\n        display: flex;\n      }\n\n      & > :not(:last-child) {\n        margin-right: 8px;\n      }\n    }\n  }\n\n  .DashboardCard-title {\n    @include line-clamp(1);\n  }\n\n  .DashboardCard-description {\n    font-size: 12px;\n    color: var(--color_neutral_900);\n    @include line-clamp(1);\n    margin-top: 10px;\n  }\n\n  .DashboardCard-jobType {\n    font-size: 10px;\n    color: var(--color_neutral_500);\n  }\n\n  .DashboardCard-details {\n    font-size: 12px;\n    color: var(--color_neutral_500);\n    @include line-clamp(1);\n  }\n}\n\n.CardMenu-container {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  transition: 0.16s ease-in-out;\n\n  visibility: hidden;\n  opacity: 0;\n\n  .CardMenu-button {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: rgba(43, 43, 43, 0.3);\n    backdrop-filter: blur(5px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    &:hover {\n      background: rgba(208, 178, 255, 0.3);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
